import Keycloak from "keycloak-js";
import React, { createContext, useContext, useEffect } from "react";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM ? "ssc-portal" : "",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ? "ssc-portal" : "",
});

const KeycloakContext = createContext<Keycloak | null>(null);

const suspense: {
  promise: Promise<Keycloak> | null;
  result: Keycloak | null;
} = {
  promise: null,
  result: null,
};
function useInitKeycloak() {
  if (!suspense.promise) {
    suspense.promise = new Promise((resolve, reject) => {
      keycloak
        .init({
          enableLogging: true,
          onLoad: "login-required",
        })
        .then(() => {
          keycloak
            .loadUserProfile()
            .then(() => {
              resolve(keycloak);
              suspense.result = keycloak;
            })
            .catch(reject);
        })
        .catch(reject);
    });
  }

  if (!suspense.result) {
    throw suspense.promise;
  }

  return suspense.result;
}

export function useKeycloak() {
  return useContext(KeycloakContext) || keycloak;
}

export default function KeycloakProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const keycloak = useInitKeycloak();
  // const applicationInsights = useApplicationInsights();

  useEffect(() => {
  }, [keycloak]);

  return (
    <KeycloakContext.Provider value={keycloak}>
      {children}
    </KeycloakContext.Provider>
  );
}
